require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./management-of-logistics-healthcare-supply-chain-academy-cas-2-4-1-1.json") })
        }
      }, "path---management-of-logistics-healthcare-supply-chain-academy-cas-2-4-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---management-of-logistics-healthcare-supply-chain-academy-cas-2-4-1-1!./.cache/json/management-of-logistics-healthcare-supply-chain-academy-cas-2-4-1-1.json
// module id = 486
// module chunks = 231608221292675